import React from "react";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import banner from "../assets/contact.jpg";
import ContactForm from "./contactForm";
export default function Contact() {
  return (
    <div>
       <div
        style={{
          width: "100%",
          height: "300px",         
          backgroundImage: `url(${banner})`,
          backgroundSize: "cover",  
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff"
        }}
      >
        <h1>Contact Us</h1>
      </div>

    <div className="p-4">
        <div className="grid">
          <div className="col-12 md:col-6">
            <Card title="Contact Information" className="contact-info-card">
              <p><strong>Career</strong></p>
              <p>PESIL has multiple positions for candidates with administration, support & development experience in DOORS Classic 9, DOORS Next Generation (DNG), Engineering Workflow Manager (EWM), Rational Publishing Engine (RPE / PUB), OSLC / REST API Developers.</p>

              <Divider />

              <p><strong > Send your resume / Business Enquires </strong></p>
   <p className="mb-2 contact-item">
              <i className="pi pi-envelope mr-2"></i>
              <a href="mailto:hr@pesilinfosol.com">hr@pesilinfosol.com</a>
            </p>


              <Divider />
                  <p><strong>Phone</strong></p>
    <p className="mb-2 contact-item">
              <i className="pi pi-phone mr-2"></i>
              <a href="tel:+919442532239">+91-94425-32239</a>
            </p>
              <Divider />

              <p><strong>Office Address</strong></p>
              <p className="contact-item flex align-items-start">
  <i className="pi pi-map-marker mr-2 mt-1"></i>

  <span>
    <strong style={{color:"firebrick"}}>PESIL InfoSol Private Limited</strong><br />
    #21/5, South Center Block,<br />
    D'Silva Layout, Whitefield,<br />
    Bangalore - 560066,<br />
    Karnataka, India
  </span>
</p>

            </Card>
          </div>
          <div className="col-12 md:col-6">
            <Card title="Send Us a Message">
          <ContactForm/>
            </Card>
          </div>

        </div>
      </div>
    </div>
  );
}
